var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg8(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 106,
    viewBox: "0 0 60 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_2805_1696)",
    shapeRendering: "geometricPrecision"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.061 23.84v7.56c0 10.8-6.84 14.04-8.88 15 2.16.84 10.08 3.96 10.08 15.36V75.2c0 11.64-5.64 20.4-21.6 20.4h-3.12c-16.56 0-21.24-8.76-21.24-20.4V61.76c0-11.16 7.56-14.52 9.6-15.36-2.04-.96-8.52-4.2-8.52-15v-7.56c0-12 4.68-19.44 20.64-19.44h2.4c15.24 0 20.64 7.44 20.64 19.44zm-15 8.4v-7.32c0-5.4-2.04-7.68-6.84-7.68-4.56 0-6.72 2.28-6.72 7.68v7.2c0 5.28 2.04 8.04 6.84 8.04 4.68 0 6.72-2.76 6.72-7.92zm.24 41.4v-11.4c0-4.92-2.04-8.28-7.08-8.28s-6.96 3.12-6.96 8.28v11.4c0 5.16 1.92 8.28 7.08 8.28 4.8 0 6.96-3.12 6.96-8.28z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.061 23.84v7.56c0 10.8-6.84 14.04-8.88 15 2.16.84 10.08 3.96 10.08 15.36V75.2c0 11.64-5.64 20.4-21.6 20.4h-3.12c-16.56 0-21.24-8.76-21.24-20.4V61.76c0-11.16 7.56-14.52 9.6-15.36-2.04-.96-8.52-4.2-8.52-15v-7.56c0-12 4.68-19.44 20.64-19.44h2.4c15.24 0 20.64 7.44 20.64 19.44zm-15 8.4v-7.32c0-5.4-2.04-7.68-6.84-7.68-4.56 0-6.72 2.28-6.72 7.68v7.2c0 5.28 2.04 8.04 6.84 8.04 4.68 0 6.72-2.76 6.72-7.92zm.24 41.4v-11.4c0-4.92-2.04-8.28-7.08-8.28s-6.96 3.12-6.96 8.28v11.4c0 5.16 1.92 8.28 7.08 8.28 4.8 0 6.96-3.12 6.96-8.28z",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_2805_1696",
    x: -4.199,
    y: -4.1,
    width: 63.96,
    height: 109.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2805_1696"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_2805_1696",
    result: "effect2_dropShadow_2805_1696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2805_1696",
    result: "shape"
  })))));
}
Svg8.displayName = '8';
export default Svg8;